import React from 'react';
import Header from '../../Header/Header';
import css from '../Signin.module.css';

const NoApplicationAccess = (props) => {
    return (
        <div>
            <Header />
            <br />
            <br />
            <div className={css.error}>
                You are not authorized to view this page. Kindly contact your <b>Administrator</b>
            </div>
        </div>
    );
};

export default NoApplicationAccess;
